module.exports = __webpack_public_path__ + "static/media/wrapFirstBg.faaa564e.png";